// extracted by mini-css-extract-plugin
module.exports = {"icons":"CardWithIcons_icons__WuRht","icons-container":"CardWithIcons_icons-container__39XBS"};